export default __webpack_public_path__ + "static/media/mb-logo_dark.20a551a0.png";